import { buildShopPath } from 'src/adapters/pageURLToStore/shop/shopTaxonomyPath';
import {
  adaptStoreToFilterPath,
  adaptStoreToPageURL,
} from 'src/adapters/storeToPageURL/adaptStoreToPageURL';
import { buildListingsURL } from 'src/adapters/storeToPageURL/buildListingsURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { deriveShopTaxonomyLevelsFromFacets } from 'src/redux/productsQuery/helpers/shop/deriveShopTaxonomyLevelsFromFacets';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const buildShopListingFullUrl = (state: ReduxApplicationState): string => {
  const { facets, page, taxonomyAttributes } = state.productsQuery;
  const taxonomyLevels = deriveShopTaxonomyLevelsFromFacets(facets, taxonomyAttributes);
  const filterPath = adaptStoreToFilterPath(state);
  const params = adaptStoreToPageURL(state, page);
  const hash = state.navigation.hash;

  if (!taxonomyLevels.length) {
    return buildListingsURL(
      state.router?.location?.pathname ?? state.navigation.pathname ?? '/',
      filterPath,
      params,
      hash,
    );
  }

  return buildListingsURL(buildShopPath(taxonomyLevels), filterPath, params, hash);
};

/**
 * Builds the next-state /shop URL when a facet option is toggled (in the sidebar or as a chip).
 * Recomputes the `/shop/<L1>/<L2>/...` pathname from `nextFacets` so toggling a taxonomy option
 * actually changes the URL (the generic `selectPathname + serializeFilterPath` pipeline can't
 * reconstruct the shop pathname from facets).
 */
export const buildShopFacetHref = (state: ReduxApplicationState, nextFacets: Facet[]): string =>
  buildShopListingFullUrl({
    ...state,
    productsQuery: {
      ...state.productsQuery,
      facets: nextFacets,
      page: 1,
    },
  });
